import { Component, Input, OnInit } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'topo-email-column',
    templateUrl: './email-column.component.html',
    styleUrls: ['./email-column.component.scss'],
    standalone: false
})
export class EmailColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
